import { AdminAbility } from '@repo/sdk/backoffice-abilities'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'
import { requireAdminPermission } from '@/modules/permissions/lib/require-admin-permission'

export const Route = createFileRoute('/(private)/users')({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(
					match.context.appLanguage,
					'admin-users:page_title'
				)
			}
		]
	}),
	beforeLoad: requireAdminPermission([AdminAbility.UsersManage]),
	staticData: {
		breadcrumb: 'admin-users:page_title'
	},
	component: () => <Outlet />
})
